import firebase from 'firebase'


const firebaseConfig = {
    apiKey: "AIzaSyDpoIihvM8aV0UJBDafCIbo-X_m4Ut7uYU",
    authDomain: "tesla-clone-d43eb.firebaseapp.com",
    projectId: "tesla-clone-d43eb",
    storageBucket: "tesla-clone-d43eb.appspot.com",
    messagingSenderId: "427659634201",
    appId: "1:427659634201:web:e838c186bbe1494d7dac88"
  };


  // we are intializing the firebase in our app 
  const firebaseApp = firebase.initializeApp(firebaseConfig)

  const auth = firebaseApp.auth()


  export {auth}